/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Ai_Tools_Studio_Signin_ButtonInputs */

const en_directory_ai_tools_studio_signin_button = /** @type {(inputs: Directory_Ai_Tools_Studio_Signin_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign in to start`)
};

const zh_directory_ai_tools_studio_signin_button = /** @type {(inputs: Directory_Ai_Tools_Studio_Signin_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`登录开始`)
};

/**
* | output |
* | --- |
* | "Sign in to start" |
*
* @param {Directory_Ai_Tools_Studio_Signin_ButtonInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_ai_tools_studio_signin_button = /** @type {((inputs?: Directory_Ai_Tools_Studio_Signin_ButtonInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Ai_Tools_Studio_Signin_ButtonInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_ai_tools_studio_signin_button(inputs)
	return zh_directory_ai_tools_studio_signin_button(inputs)
});
export { directory_ai_tools_studio_signin_button as "directory.ai_tools.studio.signin_button" }